import { Directive, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { map, filter, debounceTime, tap, switchAll } from 'rxjs/operators';


@Directive({
    selector: '[skipContent]',
})
export class SkipContentDirective {

    @Input('elementId')
    public elementId = '';

    @HostListener("keydown", ["$event"])
    onKeyDown(e: KeyboardEvent): any {
        if (e.keyCode === 13 || e.key === 'Enter') {
            console.log('------------------------------sdf', this.elementId)
            e.stopPropagation();
            e.preventDefault();
            let el = document.getElementById(this.elementId);
            el.focus()
        }
    }
    
}